import { FormControl } from 'baseui/form-control'
import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import useMeterInput from '@/containers/SubscriptionFormPageNew/Components/ElectricityMeter/Fields/MeterInput/useMeterInput'
import PdlSearchButton from '@/containers/SubscriptionFormPageNew/Components/ElectricityMeter/PdlSearch/PdlSearchButton'
import getError from '@/containers/SubscriptionFormPageNew/getError'
import CopyEndEnhancer from '@/shared/components/SDComponentsNewDesign/CopyEndEnhancer/CopyEndEnhancer'

const MeterInput = () => {
  const {
    meterIdOnBlurHandler,
    meterSerialOnBlurHandler,
    pdlNo,
    meterSerialNumber,
    showMeterSerialNumber,
    lastSentDate,
    isEditable,
    meterStatus,
    showPdlSearchButton,
    meterIdLabelKey,
    errors,
    t,
  } = useMeterInput()

  return (
    <>
      <FormControl error={getError('meter_id_elec', errors)}>
        <>
          <SDInput
            disabled={isEditable === false || lastSentDate}
            onBlur={value => meterIdOnBlurHandler(value)}
            currentValue={pdlNo}
            label={pdlNo ? t(meterIdLabelKey) : ''}
            placeholder={t('subscriptionForm:pdl_module.meter_id.placeholder')}
            status={meterStatus}
            endEnhancer={<CopyEndEnhancer value={pdlNo} />}
            button={<PdlSearchButton hidden={!showPdlSearchButton} />}
          />
        </>
      </FormControl>
      <SDFormControl hidden={!showMeterSerialNumber}>
        <SDInput
          disabled={isEditable === false || lastSentDate}
          onBlur={value => meterSerialOnBlurHandler(value)}
          currentValue={meterSerialNumber}
          label={meterSerialNumber ? t('subscriptionForm:pdl_module.meter_id.label') : ''}
          placeholder={t('subscriptionForm:pdl_module.meter_id.placeholder')}
          endEnhancer={<CopyEndEnhancer value={meterSerialNumber} />}
        />
      </SDFormControl>
    </>
  )
}

export default MeterInput
